import { FreezeWordsRequest } from './../models/api';
import Track from 'core/logger/track';
import { getParaphraserModeLabel } from 'core/utils';
import showHelp from './helpManager';
import { QuillDrawer } from 'src/_common/models/redux/store';
import { QUILL_SETTINGS } from '../constants';
import { getModeLabel } from './helper';
import { getWordCount } from '@Common/handlers/helper';

export interface languageFeedback {
  inputText: string;
  outputText: string;
  feedbackNature: string;
  inputLanguage: string;
  mode: number;
}
interface IThesaurusShown {
  submittedInputCount: number;
  segmentClickedCount: number;
}

interface ICompareModeOption {
  text: string;
  strength: keyof [-1, 0, 1, 2, 3, 4];
  fthresh: number;
}

class ParaphraseTrack {
  constructor() {}

  createdParaphraser = (
    pID: string | number,
    text: string,
    submissionID = '',
    inputLanguage?: string
  ): void => {
    Track.getInstance().storeActionEvent('createdParaphraser', {
      pID,
      text,
      submissionID,
      inputLanguage,
    });
  };
  clickedRequill = (mode: number, triggeredBy = 'sentenceControls', isSelectedOutput = true) => {
    Track.getInstance().storeActionEvent('pphr/user/clicked_next_quill_sentence', {
      mode,
      triggeredBy,
      isSelectedOutput,
    });
    Track.getInstance().ampEvent('pphr/user/clicked_next_quill_sentence', {
      mode,
      triggeredBy,
      isSelectedOutput,
    });
  };
  clickedPrevQuill = (
    triggeredBy = 'sentenceControls',
    isSelectedOutput = true,
    outputIndex?: number,
    mode?: number,
    prevMode?: number,
    flipper?: number,
    prevFlipper?: number
  ) => {
    Track.getInstance().storeActionEvent('pphr/user/clicked_prev_quill_sentence', {
      triggeredBy,
      isSelectedOutput,
      outputIndex,
      mode,
      prevMode,
      flipper,
      prevFlipper,
    });
    Track.getInstance().ampEvent('pphr/user/clicked_prev_quill_sentence', {
      triggeredBy,
      isSelectedOutput,
      outputIndex,
      mode,
      prevMode,
      flipper,
      prevFlipper,
    });
  };
  requillArticle = (
    articleLength: number,
    original: string,
    modified: string,
    editLog: any,
    submissionID: string,
    mode: number,
    fthresh: number
  ) => {
    Track.getInstance().storeActionEvent('requillArticle', {
      original,
      modified,
      editLog,
      length: articleLength,
      submissionID,
      mode,
      fthresh,
    });
    Track.getInstance().ampEvent('requillArticle', {
      length: articleLength,
      mode,
      fthresh,
      submissionID,
    });
  };

  changedWordFlipperValue = (
    newValue: number,
    triggeredBy: string,
    isSelectedOutput: boolean,
    submissionID?: string
  ) => {
    Track.getInstance().storeActionEvent('pphr/user/changed_wf_value', {
      newValue,
      triggeredBy,
      isSelectedOutput,
      submissionID,
    });
    Track.getInstance().ampEvent('pphr/user/changed_wf_value', {
      newValue,
      triggeredBy,
      isSelectedOutput,
      submissionID,
    });
  };

  clickedFeatherWF = () => {
    Track.getInstance().storeActionEvent('pphr/user/clicked_wf_premium_feather');
    Track.getInstance().ampEvent('pphr/user/clicked_wf_premium_feather');
  };

  definitionTipOpened = (thinkingTime: number, definitionWord: string, originalWord: string) => {
    Track.getInstance().storeActionEvent('pphr/user/opened_definition', {
      thinkingTime,
      definitionWord,
      originalWord,
    });
    Track.getInstance().ampEvent('pphr/user/opened_definition', {
      thinkingTime,
    });
  };

  createdOutput = (
    strength: number,
    fthresh: number,
    outID: string,
    pID: string,
    text: string,
    flipperModelId?: string,
    inputLanguage?: string
  ) => {
    Track.getInstance().storeActionEvent('createdOutput', {
      fthresh,
      strength,
      outID,
      pID,
      text,
      lang: Track.getInstance().lang,
      flipperModelId,
      inputLanguage,
      // autoflip: Globals.autoflip,
    });
  };

  redoParaphrase = (pID: string) => {
    Track.getInstance().storeActionEvent('redoParaphrase', { pID });
  };

  /*   changedParaphraserText = (pID: string, text: string, submissionID: string) => {
    Track.getInstance().storeActionEvent('changeParaphraserText', {
      pID,
      newText: text,
      submissionID,
    });
  }; */

  shownThesaurusHelp = (data: IThesaurusShown) => {
    Track.getInstance().storeActionEvent('shownThesaurusHelp', data);
    // Track.getInstance().gaEvent('thesaurus', 'shownThesaurusHelp');
    Track.getInstance().ampEvent('shownThesaurusHelp', data);
  };

  legendViewOpened = () => {
    Track.getInstance().storeActionEvent('legendViewOpened');
    Track.getInstance().ampEvent('legendViewOpened');
    // Track.getInstance().gaEvent('legend', 'legendViewOpened');
  };
  hotkeyBtnClicked = () => {
    Track.getInstance().storeActionEvent('pphr/user/clicked_hotkey_icon');
    Track.getInstance().ampEvent('pphr/user/clicked_hotkey_icon');
    // Track.getInstance().gaEvent('legend', 'legendViewOpened');
  };

  /* deleteSeg = (outID: string, origText: string, text: string) => {
    Track.getInstance().storeActionEvent('deleteSeg', {
      outID: outID,
      origText: origText,
      text: text,
    });
  }; */

  recordBeams = (
    pID: string,
    strength: number,
    beams: { [key: number]: any[] },
    text: string,
    reqTime: number,
    runTimes: any,
    inputLanguage?: string
  ) => {
    Track.getInstance().storeActionEvent('recordBeams', {
      pID: pID,
      beams: beams,
      strength: strength,
      text: text,
      reqTime: reqTime,
      fthresh: QUILL_SETTINGS.fthresh,
      runTimes: runTimes,
      inputLanguage,
    });
  };

  sentenceLocked = (paraphraserObj: { [key: string]: any }) => {
    const data = {
      fthresh: paraphraserObj.focusedOutput.fthresh,
      original: paraphraserObj.origText,
      modified: paraphraserObj.getOutputString(),
      strength: paraphraserObj.focusedOutput.strength,
      editLog: paraphraserObj.focusedOutput.editLog,
    };
    Track.getInstance().storeActionEvent('sentenceLocked', data);
    Track.getInstance().ampEvent('sentenceLocked', {
      mode: paraphraserObj.focusedOutput.strength,
      flipper: paraphraserObj.focusedOutput.fthresh,
    });
  };
  sentenceUnlocked = (paraphraserObj: { [key: string]: any }) => {
    const data = {
      fthresh: paraphraserObj.focusedOutput.fthresh,
      strength: paraphraserObj.focusedOutput.strength,
    };
    Track.getInstance().storeActionEvent('sentenceUnlocked', data);
    Track.getInstance().ampEvent('sentenceUnlocked', {
      mode: paraphraserObj.focusedOutput.strength,
      flipper: paraphraserObj.focusedOutput.fthresh,
    });
  };
  unlockAllSentences = (btnName: string) => {
    const data = {
      button: btnName,
    };
    Track.getInstance().ampEvent('allSentenceUnlocked', data);
    Track.getInstance().storeActionEvent('allSentenceUnlocked', data);
  };

  thesaurusButtonClick = (
    eventName: string,
    segModelId: string,
    phrase: string,
    thinkingTime: number
  ) => {
    thinkingTime = +(+thinkingTime).toFixed(2);
    let data = {
      segModelId,
      thinkingTime,
    };
    Track.getInstance().ampEvent(eventName, data);
    Track.getInstance().storeActionEvent(eventName, { ...data, phrase });
  };

  sentenceDeletedCount = (totalDeletedSentences?: number, sentenceCount?: number) => {
    Track.getInstance().ampEvent('userDeletedSentence', {
      totalDeletedSentences,
      sentenceCount,
    });
  };

  copiedArticle = (
    submissionID: string,
    inputLanguage: string,
    original: string,
    modified: string,
    editLog: any,
    usedModelIds: string[],
    frozenWords: string[],
    triggeredBy: string,
    selectedText: string,
    outputEdited: boolean
  ) => {
    //console.log("copied article")
    var data: {} = {
      submissionID,
      original: original,
      modified: modified,
      lang: Track.getInstance().lang,
      // ip: ip, // @TODO check whether ip is required here
      editLog: editLog,
      autoflip: QUILL_SETTINGS.autoflip,
      usedModelIds: usedModelIds && usedModelIds.length ? usedModelIds : undefined,
      frozenWords: frozenWords && frozenWords.length > 0 ? frozenWords : undefined,
      triggeredBy,
      inputLanguage,
      selectedText: selectedText !== '' ? selectedText : undefined,
      outputEdited,
    };
    if (triggeredBy === 'insertButton')
      Track.getInstance().ampEvent('pphr/user/clicked_insert_into_doc');

    Track.getInstance().storeActionEvent('copiedArticle', data);
    Track.getInstance().ampEvent('copiedArticle', { triggeredBy, outputEdited, submissionID });
  };

  copiedText = (
    submissionID: string,
    inputLanguage: string,
    original: string,
    beamOutput: string,
    flippedoutput: string,
    modified: string,
    strength: number,
    editLog: any,
    times: number,
    fthresh: number,
    frozenWords: string[],
    changedWordsCount: number,
    waltedCount: number,
    thesaurusedCount: number,
    flipperModelId?: string,
    modelId?: string,
    triggeredBy?: string,
    isSelectedOutput?: boolean,
    segmentorModelID?: string,
    totalSegmentCount?: number,
    totalBreakButtonClick?: number,
    totalOutputCreated?: number
  ) => {
    var data = {
      submissionID,
      times: times,
      fthresh: fthresh,
      original: original,
      beamOutput: beamOutput,
      flippedoutput: flippedoutput,
      modified: modified,
      strength: strength,
      lang: Track.getInstance().lang,
      // ip: ip, // @TODO check whether ip is required here
      editLog: editLog,
      modelId: modelId || undefined,
      triggeredBy,
      isSelectedOutput,
      frozenWords: frozenWords && frozenWords.length > 0 ? frozenWords : undefined,
      inputLanguage,
      changedWordsCount,
      waltedCount,
      thesaurusedCount,
      flipperModelId,
      segmentorModelID,
      totalSegmentCount,
      totalBreakButtonClick,
      totalOutputCreated,
    };
    //console.log("TRACK COPY")
    // if (isInserted) {
    //   // Track.getInstance().storeActionEvent('pphr/user/clicked_insert_into_doc', data);
    //   Track.getInstance().gaEvent('models', 'pphr/user/clicked_insert_into_doc', 'str-' + strength);
    //   Track.getInstance().ampEvent('pphr/user/clicked_insert_into_doc', {
    //     mode: strength,
    //     flipper: fthresh,
    //   });
    //   //return;
    // }

    Track.getInstance().storeActionEvent('copiedText', data);
    Track.getInstance().gaEvent('models', 'copiedText', 'str-' + strength);
    if (window && window.ga) window.ga('set', 'metric1', '1'); // @TODO: check whether this metric is required
    const modelID = modelId || undefined;
    Track.getInstance().ampEvent('copiedText', {
      mode: strength,
      flipper: fthresh,
      modelId: modelID,
      changedWordsCount,
      waltedCount,
      thesaurusedCount,
      flipperModelId,
      triggeredBy,
      segmentorModelID,
      totalSegmentCount,
      totalBreakButtonClick,
      totalOutputCreated,
      submissionID,
    });
  };

  segmentClicked = (
    origText: string,
    text: string,
    outID: string,
    inputLanguage?: string,
    submissionID?: string
  ) => {
    Track.getInstance().storeActionEvent('segmentClicked', {
      origText,
      text,
      outID,
      inputLanguage,
      submissionID,
    });
    showHelp('segmentClicked'); // @TODO add this function
    //gEvent("thesaurus", "segmentClicked")
    //ga('set', 'metric3', '1');

    Track.getInstance().ampEvent('segmentClicked', { submissionID });
  };

  thesaurused = (
    origText: string,
    text: string,
    newWord: string,
    outID: string,
    type: boolean,
    walted: boolean,
    waltedText: string,
    thinkingTime: number,
    seg: any,
    context: string,
    fthresh: number,
    modelId?: string,
    inputLanguage?: string,
    segModelId?: number,
    altIndex?: number,
    altSource?: string
  ) => {
    let key = seg.key;
    if (key === undefined) {
      key = 'unknown-' + seg.index;
    }
    let altsShown: any[] = [];
    if (seg.shownAlts) {
      altsShown = altsShown.concat(seg.alts.slice(0, seg.altsShown).map((x: any) => x.displayText));
    }
    if (seg.shownFiller) {
      altsShown = altsShown.concat(
        seg.fillers.slice(0, seg.altsShown).map((x: any) => x.displayText)
      );
    }
    thinkingTime = +(+thinkingTime).toFixed(2);
    const containsWalt = false;

    var thesData = {
      altsShown: altsShown,
      key: key,
      origText: origText,
      text: text,
      outID: outID,
      newWord: newWord,
      type: type,
      walted: walted,
      waltedText: waltedText,
      thinkingTime: thinkingTime,
      segDepPhrase: seg.depPhrase,
      context: context,
      fthresh,
      submissionID: seg.output.paraphraser.submissionID,
      flipperModelId: modelId,
      inputLanguage,
      segModelId,
      altIndex,
      altSource,
    };

    Track.getInstance().storeActionEvent('thesaurused', thesData);

    Track.getInstance().ampEvent('thesaurused', {
      flipperModelId: modelId,
      isWalted: newWord === origText,
      containsWalt: Boolean(waltedText),
      fthresh,
      segModelId,
      altSource,
      altIndex,
      thinkingTime,
      submissionID: seg.output.paraphraser.submissionID,
    });
    //console.log(thesData)
    //gEvent("thesaurus", "thesaurus")
    if (window && window.ga) window.ga('set', 'metric4', '1');
  };

  submittedInput = (
    input: string,
    submissionID: string,
    fthresh: number,
    strength: number,
    sentenceCount: number,
    splitBy: string,
    inputLanguage?: string
  ) => {
    const existingInputSubmitCount = Track.getInstance().storeActionEvent('submittedInput', {
      input: input,
      submissionID: submissionID,
      sentenceCount,
      inputLanguage,
      splitBy,
      mode: strength,
      flipper: fthresh,
    });
    // @TODO: remove help from here and put at proper place
    showHelp('submittedInput');
    Track.getInstance().gaEvent('paraphrase', 'submittedInput');
    if (window && window.ga) window.ga('set', 'metric5', '1');
    Track.getInstance().ampEvent('submittedInput', {
      mode: strength,
      flipper: fthresh,
      sentenceCount,
      inputLanguage,
      charCount: input.length,
      wordCount: getWordCount(input),
      splitBy,
      submissionID,
    });
    Track.getInstance().gTagEvent('submittedInput');
  };

  maxedChars = (limit: number, inputTextLength: number, wordCount: number) => {
    Track.getInstance().storeActionEvent('maxedChars', {
      limit,
      inputLength: inputTextLength,
      wordCount,
    });
    Track.getInstance().ampEvent('maxedChars', {
      limit,
      inputLength: inputTextLength,
      wordCount,
    });
    Track.getInstance().gTagEvent('maxedChars', {
      limit,
      inputLength: inputTextLength,
      wordCount,
    });
  };

  premiumLinkClicked = (linkPosition: string) => {
    Track.getInstance().premiumLinkClicked(linkPosition);
  };
  hotKeyPressed = (keyCode: string, action: string) => {
    const actionName = 'pphr/user/pressed_hotkey';
    Track.getInstance().storeActionEvent(actionName, { keyCode: keyCode, action: action });
    Track.getInstance().ampEvent(actionName, { keyCode: keyCode, action: action });
  };

  pasteFromClipboard = (triggeredBy: string, textLength: number = -1) => {
    const actionName = 'pphr/user/pasted_text';
    Track.getInstance().storeActionEvent(actionName, {
      textLength: textLength >= 0 ? textLength : undefined,
      triggeredBy: triggeredBy,
    });
    Track.getInstance().ampEvent(actionName, { textLength: textLength, triggeredBy: triggeredBy });
  };

  clickedTrySampleButton = (trySampleStep: number, triggeredBy: string) => {
    const actionName = 'pphr/user/clicked_try_sample_button';
    const step = trySampleStep + 1;
    Track.getInstance().storeActionEvent(actionName, {
      step,
      triggeredBy,
    });
    Track.getInstance().ampEvent(actionName, { step, triggeredBy });
  };

  togglePriority = (
    strength: number,
    triggeredBy: string,
    currentStrength: number,
    submissionID?: string
  ) => {
    // console.log("toogled priority");
    // const modeLabel = getModeLabel(strength); // TODO: uncomment this post merge
    const modeLabel = getParaphraserModeLabel(strength);
    Track.getInstance().storeActionEvent('toggledPriority', {
      to: strength,
      modeLabel,
      triggeredBy,
      from: currentStrength,
      submissionID,
    });
    Track.getInstance().ampEvent('togglePriority', {
      to: strength,
      modeLabel,
      triggeredBy,
      from: currentStrength,
      submissionID,
    });
  };

  toggleStats = (toogleState: boolean) => {
    Track.getInstance().storeActionEvent('toggleStats', { toggled: toogleState });
  };

  sideDrawerStateChanged = (
    state: 'opened' | 'closed',
    drawerName: QuillDrawer,
    triggeredBy = 'sideControlBar'
  ) => {
    Track.getInstance().storeActionEvent('sideDrawerStateChanged', {
      state,
      drawerContent: drawerName,
      triggeredBy,
    });
    Track.getInstance().ampEvent('sideDrawerStateChanged', {
      state,
      drawerContent: drawerName,
      triggeredBy,
    });
  };

  viewedStatFilter = (filter: string) => {
    Track.getInstance().storeActionEvent('viewedStatFilter', { filter });
  };

  triggerPanic = (reason: string, mode: string) => {
    Track.getInstance().storeActionEvent('panic', { reason, mode });
  };
  undoSwap = () => {
    Track.getInstance().storeActionEvent('undoSwapSentence');
  };
  splitterMoved = () => {
    Track.getInstance().storeActionEvent('splitterMoved');
    Track.getInstance().ampEvent('splitterMoved');
  };
  // selStrength = (strength: number) => {
  //   Track.getInstance().storeActionEvent('selStrength', { strength });
  // };
  swapPara = (focusID: number, newID: number, focusPID: string, newPID: string) => {
    Track.getInstance().storeActionEvent('swapPara', { focusID, newID, focusPID, newPID });
  };
  setChromeUrl = (url: string) => {
    Track.getInstance().setChromeExtHost(url);
  };
  submittedSentence = (
    strength: number,
    inputText: string,
    modelId?: string,
    compareModeCall?: boolean,
    inputLanguage?: string
  ) => {
    Track.getInstance().ampEvent('submittedSentence', {
      mode: strength,
      modelId,
      numOfChars: inputText.length,
      wordCount: getWordCount(inputText),
      inputLanguage,
    });
    Track.getInstance().storeActionEvent('submittedSentence', {
      strength,
      modelId,
      inputSent: inputText,
      inputLanguage,
      // compareModeCall, // TODO: need to discuss
    });
  };
  selectedSentenceCompareMode = (
    original: string,
    selectedStrength: number,
    optionsShown: ICompareModeOption[],
    selectedOptionIndex: number,
    inputLanguage?: string
  ) => {
    const dataStoreObj = {
      original: original,
      selected: selectedOptionIndex,
      selectedStrength: selectedStrength,
      options: optionsShown,
      inputLanguage,
    };

    const getSelectedOption = (opt: ICompareModeOption[]) => {
      let output;
      for (let i = 0; i < opt.length; i++) {
        if (opt[i].strength === selectedStrength) {
          output = opt[i];
          break;
        }
      }
      return output;
    };

    const amplitudeData = {
      submittedChar: original.length,
      selectedChar:
        selectedStrength === -1 ? original.length : getSelectedOption(optionsShown)?.text.length,
      selectedMode: getModeLabel(selectedStrength),
      selectedStrength: selectedStrength,
      selectedFthresh: selectedStrength === -1 ? -1 : getSelectedOption(optionsShown)?.fthresh,
      inputLanguage,
    };

    Track.getInstance().storeActionEvent('pphr/user/selectedModeOutput', dataStoreObj);
    Track.getInstance().ampEvent('pphr/user/selectedModeOutput', amplitudeData);
  };
  addFreezeWord = (frozenWords: string[]) => {
    Track.getInstance().storeActionEvent('addedFreezeWord', { frozenWords });
    Track.getInstance().ampEvent('addedFreezeWord', { numberOfWords: frozenWords.length });
  };
  freezeWordClicked = () => {
    Track.getInstance().storeActionEvent('freezeWordClicked');
    Track.getInstance().ampEvent('freezeWordClicked');
  };
  freezeWordPopperOpened = () => {
    Track.getInstance().storeActionEvent('pphr/user/opened_freeze_words_popper');
    Track.getInstance().ampEvent('pphr/user/opened_freeze_words_popper');
  };
  freezerSentEmptyArrayResponse = (requestObj: FreezeWordsRequest) => {
    Track.getInstance().storeActionEvent('freezerSentEmptyArrayResponse', {
      requestData: requestObj,
    });
    Track.getInstance().ampEvent('freezerSentEmptyArrayResponse', { frozenWords: requestObj.keep });
  };

  spanishlanguageFeedback = (
    inputText: string,
    outputText: string,
    feedbackNature: string,
    inputLanguage: string,
    mode: number
  ) => {
    Track.getInstance().storeActionEvent('multiLanguageParaphrasingFeedback', {
      inputText,
      outputText,
      feedbackNature,
      inputLanguage,
      mode,
    });
    Track.getInstance().ampEvent('multiLanguageParaphrasingFeedback', {
      inputTextLength: inputText.length,
      outputTextLength: outputText?.length,
      feedbackNature: feedbackNature,
      inputLanguage: inputLanguage,
      mode: mode,
    });
  };

  // showNextQuillTooltip = () => {
  //   Track.getInstance().storeActionEvent('pphr/system/shownNextQuillTooltip');
  //   Track.getInstance().ampEvent('pphr/system/shownNextQuillTooltip');
  // };

  systemClosedRequillTooltip = (time: number) => {
    const actionName = 'pphr/system/closed_next_quill_tooltip';
    Track.getInstance().storeActionEvent(actionName, { timetaken: time });
    Track.getInstance().ampEvent(actionName, { timetaken: time });
  };

  userClosedRequillTooltip = () => {
    const actionName = 'pphr/user/closed_next_quill_tooltip';
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  requillTooltipOpened = () => {
    const actionName = 'pphr/system/shown_next_quill_tooltip';
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  recommendedWordClicked = () => {
    const actionName = 'pphr/user/clicked_recommended_word';
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  userClickedOnLastParaphraserButton = (
    status: string,
    charCount?: number,
    sentenceCount?: number,
    timeSpentOnArticle?: number
  ) => {
    const actionName = 'pphr/user/clicked_last_paraphrased_button';
    const data = {
      status,
      charCount,
      sentenceCount,
      timeSpentOnArticle,
    };
    Track.getInstance().storeActionEvent(actionName, data);
    Track.getInstance().ampEvent(actionName, data);
  };

  changedBeamsPopperState = (
    status: string,
    focusedSentenceIndex?: number,
    sentenceCount?: number,
    mode?: number,
    fthresh?: number,
    submissionID?: string,
    beampopperOpenTime?: number
  ) => {
    const actionName = `pphr/user/${status}_beams_popper`;
    Track.getInstance().storeActionEvent(actionName, {
      focusedSentenceIndex,
      sentenceCount,
      mode,
      fthresh,
      beampopperOpenTime,
      submissionID,
    });
    Track.getInstance().ampEvent(actionName, { mode, fthresh, submissionID });
  };

  selectedSentenceFromOptions = (
    sentenceStrength: number,
    selectedSentence: string,
    selectedBeam: string,
    triggeredBy: string,
    originalSentence: string,
    wordFlipperValue?: number,
    beamsPerStrength?: { [key: number]: string[] },
    submissionID?: string,
    index = 0
  ) => {
    const actionName = 'pphr/user/selected_sentence_from_beams';
    const data = {
      mode: sentenceStrength,
      selectedSentence,
      selectedBeam,
      triggeredBy,
      originalSentence,
      flipper: wordFlipperValue,
      beamsPerStrength,
      submissionID,
      selectedSentencePosition: index + 1,
    };
    Track.getInstance().storeActionEvent(actionName, data);
    Track.getInstance().ampEvent(actionName, {
      sentenceStrength,
      triggeredBy,
      submissionID,
      selectedSentencePosition: index + 1,
    });
  };

  rephraseTooltipOpened = () => {
    const actionName = 'pphr/system/showed_rephrase_tooltip_for_next_beam';
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  showedThreeBeamEducationVideo = () => {
    const actionName = 'pphr/system/showed_three_beam_education_video';
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  premiumUpsaleAction = (actionName: string) => {
    Track.getInstance().storeActionEvent(actionName);
    Track.getInstance().ampEvent(actionName);
  };

  userClickedUndo = (lastSubmission: string) => {
    Track.getInstance().storeActionEvent('pphr/user/clicked_undo_after_delete', {
      lastSubmittedInputLength: lastSubmission.length,
      lastSubmittedInputWordCount: getWordCount(lastSubmission),
    });
    Track.getInstance().ampEvent('pphr/user/clicked_undo_after_delete', {
      lastSubmittedInputLength: lastSubmission.length,
      lastSubmittedInputWordCount: getWordCount(lastSubmission),
    });
  };

  threeBeamsOnBoarding = (refrrer: string) => {
    Track.getInstance().storeActionEvent('pphr/system/showed_three_beams_onBoarding', { refrrer });
    Track.getInstance().ampEvent('pphr/system/showed_three_beams_onBoarding', { refrrer });
  };

  userActionOnthreeBeamsOnBoarding = (refrrer: string, action: string) => {
    Track.getInstance().storeActionEvent('pphr/user/action_on_three_beams_onboard', {
      refrrer,
      action,
    });
    Track.getInstance().ampEvent('pphr/user/action_on_three_beams_onboard', { refrrer, action });
  };
}

const pphrTrack = new ParaphraseTrack();
export default pphrTrack;
